import { SagaIterator } from 'redux-saga';
import { select } from 'redux-saga/effects';
import { isIProjectItemInfo, ISpaceTypeInfo } from '../../../ts/models/resourceInfoParts';
import { ContentActions } from '../../../ts/services/ContentActions';
import { NewFlowForDatasourceAction } from '../../actions/spaces/NewFlowForDatasourceAction';
import { SessionSiteSelectors } from '../../selectors/SessionInfoSelectors';
import { ServiceLocator } from '../../ServiceLocator';

export function* handleNewFlowForDatasourceAction(action: NewFlowForDatasourceAction): SagaIterator {
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  let projectId;
  if (isIProjectItemInfo(action.contentInfo)) {
    projectId = action.contentInfo.project.id;
  }
  ServiceLocator.get<ContentActions>('ContentActions').newFlow(siteUrlName, action.contentInfo as ISpaceTypeInfo<'datasource'>, projectId);
}
